/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC, FunctionComponent } from "react"
import { observer } from "mobx-react-lite"
import { isAlive } from "mobx-state-tree"
import {
  StatusBar, Badge, BadgeText,
  Button as Button2, Box,
  ButtonIcon, VStack, HStack,
  Input,
  InputSlot,
  InputIcon,
  SearchIcon, GripVerticalIcon,
  InputField,
} from "@gluestack-ui/themed";
import { View, Text, AppState, Linking, Platform, ScrollView, Pressable, StyleSheet, Keyboard, Modal } from "react-native"
import Spacer from "../components/base/Spacer"
import { useFocusEffect } from '@react-navigation/native';
import { SwipeListView } from 'react-native-swipe-list-view';


import NetInfo from '@react-native-community/netinfo';

import { Button, Icon, } from "native-base"

import { MaterialIcons, Ionicons, MaterialCommunityIcons, FontAwesome5 } from "@expo/vector-icons";

import { HomeStackParamList, useBackButtonHandler } from "../navigators"
import { DrawerScreenProps } from "@react-navigation/drawer"
import { useStores } from "../models"
import { ITEM_STATUS } from "../voolks/types";
import { getIconItem, getItemTitle, openPDF, getIconItemPTW } from "../utils/itemCommonFunctions";
import * as Storage from "../utils/storage";

import { glueStyles } from "../configGlueStack/gluestack-ui.config";
import { DateTimePicker , ModalIconInfo, ModalInfo, ModalInfoProps, WorkflowSteps } from "../components";
import { RNPicker } from "../components/base/RNPicker";
import { ModalGraph } from "../components/ModalGraph";




const ItemRow = React.memo(({ item, department, form, onPress, isSwiping, currentStateOnly,statusStore ,onLayout}: any) => {
  const stepNumber = (item.membersId == null ? -1 : (item.stepNumber ?? 1)) + 1;
  
  const handleMainPress = React.useCallback(() => {
    onPress(form, department, item);
    statusStore.setHintMessage("", "", undefined, undefined);
  }, [item.id]);

  const handleStepHint = React.useCallback((val: string) => {
    const userStep = val || "N/D";
    statusStore.setHintMessage("Asignado a ", userStep.split("|").pop());
  }, []);

  
  return (
    <View key={item.id} style={styles.itemContainer} onLayout={onLayout}>
      <View style={styles.innerRow}>
        {getIconItem(item.status, item.statusWarning?"warning.400": undefined)}
        <View style={styles.contentWrapper}>
          <Pressable key={item.id+"onPress"} onPress={handleMainPress} disabled={isSwiping}>
            <View style={styles.titleRow}>
              <Text style={styles.itemTitle}>{item.title}</Text>
              {getIconItemPTW(item.statusPTW)}
            </View>
            <View style={styles.subInfoRow}>
              <Text style={styles.subText}>
                {department.name} {form.name} {item.statusPTW=="closed" ? "": "".concat(stepNumber + 1 ,"/",form.workflow.steps.length + 1)} 
              </Text>
              {item.statusPTW !== "closed" ? (
                <WorkflowSteps 
                  steps={form.workflow}
                  currentStep={stepNumber}
                  currentStateOnly={currentStateOnly}
                  itemPayload={item.payload}
                  onStepPress={handleStepHint}
                />
              ):<></>}
            </View>
          </Pressable>
        </View>
        <Spacer />
        <Pressable key={item.id+"arrow-forward"} onPress={handleMainPress}>
          <Ionicons name="chevron-forward" size={24} color={glueStyles.colors.light400} />
        </Pressable>
      </View>
    </View>
  );
}, (prev, next) => {
  // Solo re-renderizar si cambian propiedades críticas
  return (
    prev.item.status === next.item.status &&
    prev.item.statusPTW === next.item.statusPTW &&
    prev.item.stepNumber === next.item.stepNumber &&
    prev.item.title === next.item.title
    // Eliminamos isSwiping de aquí para evitar re-render global
  );
});
ItemRow.displayName = "ItemRow";

const HiddenActions = React.memo(({ item, form, department, onClone, onPDF, onRemove }: any) => {
  return (
    <View style={styles.hiddenActionWrapper}>
      <View style={styles.actionGroup}>
        <Pressable
          style={[styles.actionButton, { backgroundColor: glueStyles.colors.violet500 }]} // violet500
          onPress={() => onClone(form, department, item)}
        >
          <Ionicons name="copy" size={22} color="#FFF" />
        </Pressable>

        <Pressable
          disabled={item.status !== "sent" && item.id === undefined}
          style={[styles.actionButton, { backgroundColor: glueStyles.colors.success500 }]} // success500
          onPress={() => onPDF(item)}
        >
          <FontAwesome5 name="file-pdf" size={20} color="#FFF" />
        </Pressable>

        <Pressable
          disabled={item.status !== "sent" && item.id === undefined}
          style={[styles.actionButton, { backgroundColor: glueStyles.colors.yellow500 }]} // yellow500
          onPress={() => onPDF(item, true)}
        >
          <Ionicons name="mail" size={22} color="#FFF" />
        </Pressable>
      </View>

      <Spacer />

      <Pressable
        style={[styles.actionButton, { backgroundColor: glueStyles.colors.danger500 }]} // danger500
        onPress={() => onRemove(department, form, item)}
      >
        <Ionicons name="trash-outline" size={22} color="#FFF" />
      </Pressable>
    </View>
  );
});
HiddenActions.displayName = "HiddenActions";

export const WorkflowsScreen: FC<DrawerScreenProps<HomeStackParamList, "ItemsList">> = observer(function WorkflowsScreen({ navigation, route }) {
  const fcName = "WorkflowsScreen";
  console.log(fcName);
  let itemlistStatus=route.params.itemlistStatus;
  if(typeof(itemlistStatus)!="object")
    itemlistStatus = {};
  const [isSwiping, setIsSwiping] = React.useState(false);
  const { formsStore, itemsStore, statusStore, authenticationStore } = useStores();
  const [keyboardHeight, setKeyboardHeight] = React.useState(0);
  const [isConnected, setIsConnected] = React.useState<boolean>(true);
  
  React.useEffect(() => {
    const unsubscribe = NetInfo.addEventListener((state) => {
      setIsConnected(state.isConnected ?? false);
    });
    return () => unsubscribe();
  }, []);

  React.useEffect(() => {
    const showEvent = Platform.OS === "ios" ? "keyboardWillShow" : "keyboardDidShow";
    const hideEvent = Platform.OS === "ios" ? "keyboardWillHide" : "keyboardDidHide";
    
    const showSub = Keyboard.addListener(showEvent, (e) => {
      setKeyboardHeight(e.endCoordinates.height);
    });
    const hideSub = Keyboard.addListener(hideEvent, () => {
      setKeyboardHeight(0);
    });

    return () => {
      showSub.remove();
      hideSub.remove();
    };
  }, []);
  const [showGraph, setShowGraph] = React.useState<boolean>(false);
  const [alertDialog, setAlertDialog] = React.useState<ModalInfoProps["alertDialog"]>(undefined);
  const [itemsPending, setItemsPending] = React.useState<boolean>(itemlistStatus?.itemsPending ?? true);
  const [mustSync, setMustSync] = React.useState<boolean>(false);
  const [selectNewForm, setSelectNewForm] = React.useState<boolean | undefined>(false);
  const [showIconInfo, setShowIconInfo] = React.useState(false);
  const currentStateOnly = statusStore.windowDimensions.width < 900;
  const [filterView, setFilterView] = React.useState<boolean | undefined>(itemlistStatus?.filterView ?? false);
  const [search, setSearch] = React.useState(itemlistStatus?.search ?? "");
  const [filterDateJob, setFilterDateJob] = React.useState(itemlistStatus?.filterDateJob ?? undefined);
  const [filterForm, setFilterForm] = React.useState(itemlistStatus?.filterForm ?? { id: undefined, name: "" });
  const [filterAutonumeric, setFilterAutonumeric] = React.useState(itemlistStatus?.filterAutonumeric ?? undefined);
  const swipeRows: any[] = [];
  let my_items: any = [];
  let departments: any = [];
  const listViewRef = React.useRef(null);
  const offsetRef = React.useRef(itemlistStatus?.offset ?? 0);

  const goBack = () => null

  useBackButtonHandler(goBack)
  const handleSearch = (text: string) => {
    setSearch(text);
    console.log(text);
  }

  const _openItem = async (form, department, itemSelected: any = undefined) => {
    console.log(fcName, "_openItem", "Init");
    if (itemSelected)
      await itemsStore.activateItem(itemSelected)
    if (itemsStore.itemActiveIDX != undefined) {
      await itemsStore.makePayloadFromFormPages(form.pages);
      navigation.navigate("ItemDetails", {
        itemStartedAt: new Date().getTime(),
        formId: form.id,
        deptId: department.id,
        forReview: itemsStore.itemActive.status != ITEM_STATUS.draft.toString(),
        taskId: undefined,
        pageActive: 0,
        rnd: new Date().getTime(),
        itemlistStatus:{itemsPending,filterView,search,filterDateJob,filterForm,filterAutonumeric,search,offset:offsetRef.current}
      })
    }
    console.log(fcName, "_openItem", "Fin");
  }


  const newItem = async (department, form) => {
    await itemsStore.new(form, undefined)
    _openItem(form, department);
  }

  const cloneItem = async (form, department, itemSelected: any = undefined) => {
    await itemsStore.new(form, undefined, itemSelected);
    _openItem(form, department);
  }


  const openItem = async (form, department, itemSelected: any = undefined) => {
    _openItem(form, department, itemSelected);
  }


  const removeItemsDialog = async (department, form, item: any = undefined) => {
    let lstIdx: number[] = [];
    let alert = { title: "", message: "" };
    if (item != undefined) {
      let itemIdx: number = itemsStore.getIDXofItem(item)
      if (itemIdx > -1) {
        lstIdx.push(itemIdx);
      }
      alert.title = `Borrar registro ${form.name}`;
      alert.message = `¿Estas seguro de borrar el registro  ${getItemTitle(form, item)}?`;
      setAlertDialog({
        ...alert,
        action: () => {
          swipeRows.map(async (row) => {
            await row?.closeRow();
          });
          lstIdx.sort((a, b) => { return b - a; }).forEach(idx => itemsStore.removeItem(idx));
        }
      })
    }
  }

  const checkMustSync = async () => {
    setMustSync((await Storage.getItem("must_sync")) != undefined);
    console.log(mustSync)
  }

  React.useEffect(() => {
    checkMustSync();
    const listener = AppState.addEventListener("change", checkMustSync);
    return () => {
      listener.remove();
    }
  }, [])

  useFocusEffect(
    React.useCallback(() => {
      if (listViewRef.current && offsetRef.current > 0) {
        listViewRef.current?._listView?.scrollToOffset({ offset: offsetRef.current*100, animated: false });
        setTimeout(() => {
          console.log("offsetRef.current", offsetRef.current);
          listViewRef.current?._listView?.scrollToOffset({
            offset: offsetRef.current,
            animated: false,
          });
        }, 100);
      }
    }, []) 
  );
  const heightsMap = React.useRef({});
  const renderItem = React.useCallback(
    (data, rowMap) => {
      const item = data.item;
      const lookup = formLookup.get(item.formId);
      if (!lookup) return <></>;

      const { dept, form } = lookup;

      let _title = item.title;
      if (_title === undefined || _title.trim() === "") {
        _title = getItemTitle(form, item);
        item.title = _title;
      }
     
      if (item.statusPTW == "finished" && item.stepNumber > form.workflow.steps_approved && item.stepNumber < form.workflow.steps.length)
        item.statusPTW = "closing"
      return (
        <ItemRow
          key={item.id}
          item={item}
          department={dept}
          form={form}
          onPress={openItem}
          isSwiping={isSwiping}
          statusStore={statusStore}
          currentStateOnly={currentStateOnly}
          onLayout={(event) => {
           console.log ("ItemRow", item.id, event.nativeEvent.layout,data.index);
           heightsMap.current[data.index] = event.nativeEvent.layout.height;
          }}
        />
      );

    }
    ,
    [departments]);

  const renderHiddenItem = React.useCallback((data, rowMap) => {
    const item = data.item;
    const lookup = formLookup.get(item.formId);
    if (!lookup) return <></>;

    const { dept, form } = lookup;

    return (
      <HiddenActions
        item={item}
        form={form}
        department={dept}
        onClone={cloneItem}
        onPDF={(it, mail) => openPDF(itemsStore, it, mail)}
        onRemove={removeItemsDialog}
      />
    );
  }, [departments]);

  

  const ItemsListRows: FunctionComponent = () => {
    const _search=search.trim().toUpperCase();
    return (
      <SwipeListView
        ref={listViewRef}
        useFlatList={true} 
        windowSize={3}
        removeClippedSubviews={Platform.OS === 'android'}
        initialNumToRender={20}
        maxToRenderPerBatch={2}
        onScroll={(event) => {
          offsetRef.current = event.nativeEvent.contentOffset.y;
        }}
        onSwipeValueChange={({ value }) => {
          if (value !== 0) setIsSwiping(true);
          else setIsSwiping(false);
        }}
        data={filteredItems}
        style={{ width: "100%" }}
        renderItem={renderItem}
        leftOpenValue={170}
        rightOpenValue={-60}
        renderHiddenItem={renderHiddenItem}
        keyExtractor={(item, index) => {
          if (!isAlive(item)) return `dead-${index}`;
          return (item.id || item._rnd || `idx-${index}`).toString();
        }}
        getItemLayout={(data, index) => {
          // Calculamos la altura acumulada sumando las alturas reales medidas en heightsMap
          let offset = 0;
          for (let i = 0; i < index; i++) {
            offset += (heightsMap.current[i] || 86) + 2; // 86px como fallback si aún no se ha medido
          }
          
          const length = (heightsMap.current[index] || 86) + 4;

          return { length, offset, index };
        }}
      />
    )
  }

  const someToUpload = 0;

  const svgMarkerUser = {
    path: "M375.935,375.033c-10.498-5.408-22.442-10.275-35.512-14.472c-0.767-0.409-2.272-1.216-4.303-2.33 c-16.668-9.184-29.807-17.867-36.12-23.803v-24.286c30.385-17.372,51.163-48.542,57.804-86.695 C375.017,218.518,390,202.361,390,187.5c0-15.043-11.308-25.026-30-27.094V150h35v-7.5c0-9.655-8.382-46.807-27.002-47.469 C355.397,57.703,326.775,27.87,290,13.748V0h-95v13.748c-36.824,14.137-65.464,43.973-78.033,81.285 C98.372,95.74,90,132.851,90,142.5v7.5h35v10.406c-18.692,2.068-30,12.051-30,27.094c0,14.861,14.983,31.019,32.196,35.948 c6.647,38.167,27.429,69.336,57.804,86.695v24.285c-6.312,5.936-19.45,14.618-36.106,23.795c-2.06,1.13-3.577,1.943-4.338,2.349 c-13.408,4.401-25.363,9.341-35.485,14.658c-62.571,32.182-64.037,75.318-64.069,77.139L45,485h395v-32.537 C439.991,450.626,439.051,407.119,375.935,375.033z M340,376.218c9.011,3.058,17.38,6.448,25,10.127V430h-25V376.218z M375,187.5 c0,6.126-6.627,14.467-15.266,19.07c0.165-2.964,0.266-31.088,0.266-31.088C373.367,177.356,375,184.268,375,187.5z M290,29.958 C318.457,42.536,340.807,65.964,352.045,95H290V29.958z M210,15h65v80h-65V15z M195,29.956V95h-62.081 C144.134,65.976,166.5,42.545,195,29.956z M110,187.5c0-3.232,1.633-10.144,15-12.018c0,0,0.101,28.125,0.266,31.088 C116.627,201.966,110,193.626,110,187.5z M105.912,135c2.285-10.771,8.315-23.686,11.757-25h249.662 c3.442,1.314,9.472,14.229,11.757,25H105.912z M141.227,216.156C140.413,210.366,140,204.09,140,197.5V150h205v47.5 c0,6.59-0.413,12.866-1.229,18.674c-5.158,37.347-25.101,67.55-54.733,82.874C275.075,306.315,259.417,310,242.5,310 s-32.575-3.685-46.555-10.962C166.331,283.724,146.388,253.521,141.227,216.156z M285,317.299v17.312 C279.87,339.974,263.613,355,242.5,355c-20.977,0-37.346-15.055-42.5-20.404v-17.298c13.182,5.108,27.424,7.702,42.5,7.702 C257.579,325,271.824,322.405,285,317.299z M160,369.204c9.754-5.509,23.203-13.621,32.241-21.169 C200.885,356.174,219.023,370,242.5,370s41.615-13.826,50.259-21.966c9.035,7.546,22.48,15.656,32.241,21.169V430H160V369.204z M120,386.509c7.426-3.641,15.798-7.078,25-10.258V430h-25V386.509z M90.2,470H60v-17.37c0.093-2.065,2.189-31.708,45-57.922 V430.2c-8.466,1.22-15,8.502-15,17.3v20C90,468.351,90.082,469.181,90.2,470z M380,467.5c0,1.355-1.145,2.5-2.5,2.5h-270 c-1.355,0-2.5-1.145-2.5-2.5v-20c0-1.355,1.145-2.5,2.5-2.5h270c1.355,0,2.5,1.145,2.5,2.5V467.5z M425,470h-30.2 c0.118-0.819,0.2-1.649,0.2-2.5v-20c0-8.798-6.534-16.081-15-17.3v-35.764c43.445,26.306,44.951,56.392,45,58.136V470z",
    fillColor: "green",
    fillOpacity: 1,
    strokeWeight: 1,
    strokeColor: "green",
    rotation: 0,
    scale: 0.05
  };

  const svgMarkerWarning = {
    path: "M108.186,144.372c0,7.054-4.729,12.32-12.037,12.32h-0.254c-7.054,0-11.92-5.266-11.92-12.32 c0-7.298,5.012-12.31,12.174-12.31C103.311,132.062,108.059,137.054,108.186,144.372z M88.44,125.301h15.447l2.951-61.298H85.46 L88.44,125.301z M190.372,177.034c-2.237,3.664-6.214,5.921-10.493,5.921H12.282c-4.426,0-8.51-2.384-10.698-6.233 c-2.159-3.849-2.11-8.549,0.147-12.349l84.111-149.22c2.208-3.722,6.204-5.96,10.522-5.96h0.332 c4.445,0.107,8.441,2.618,10.513,6.546l83.515,149.229C192.717,168.768,192.629,173.331,190.372,177.034z M179.879,170.634 L96.354,21.454L12.292,170.634H179.879z",
    fillColor: "orange",
    fillOpacity: 1,
    strokeWeight: 1,
    strokeColor: "orange",
    rotation: 0,
    scale: 0.15
  };
  const cancelRef = React.useRef();



  const mySubscriptions = formsStore.mySubscriptions();
  //let lstForms: any[] = [];
  const departmentsData = React.useMemo(() => {
    let _lstForms: any[] = [];
    let _lstDepForms = [{ id: undefined, name: "Todos" }];
    const _departments = mySubscriptions.subscriptions.reduce((lst, dept) => {
      const wfs = [];
      for (const form of dept.forms) {
        if (form.type == "workflow") {
          wfs.push(form);
          _lstDepForms.push({ id: form.id, name: `${dept.name} - ${form.name}`, f: form });
        }
      }
      if (wfs.length > 0) {
        lst.push({ "id": dept.id, "name": dept.name, forms: wfs })
        _lstForms = _lstForms.concat(wfs)
      }
      return lst;
    }, []);

    const _newFormList = _departments.flatMap((dept: any) =>
      dept.forms.map((f: any) => ({ dept, form: f }))
    ).sort((a: any, b: any) => a.form.name.localeCompare(b.form.name));

    return { departments: _departments, lstForms: _lstForms, lstDepForms: _lstDepForms, newFormList: _newFormList };
  }, [mySubscriptions, mySubscriptions?.lastSync]);

  const { lstForms, lstDepForms, newFormList } = departmentsData;
  departments = departmentsData.departments;

  const formLookup = React.useMemo(() => {
    const map = new Map();
    departments.forEach((dept: any) => {
      dept.forms.forEach((f: any) => {
        map.set(f.id, { dept, form: f });
      });
    });
    return map;
  }, [departments]);

  my_items = React.useMemo(() => {
    console.log("reload my_items memo");
    let items = itemsStore.myItems().reverse().filter(item => {
      if (item.title == null || item.title == "") {
        item.title = getItemTitle(lstForms.find(f => f.id == item.formId), item);
      }
      return (item.formType == "workflow" && (!itemsPending || item.status != "sent" || item.statusPTW == "waiting"));
    }).sort((a, b) => a.status.localeCompare(b.status));

    let qFilterToApply = 0;
    qFilterToApply += (filterAutonumeric != undefined && filterAutonumeric.trim() != "") ? 1 : 0;
    qFilterToApply += (filterForm.id != undefined) ? 1 : 0;
    qFilterToApply += (filterDateJob != undefined && filterDateJob.trim() != "") ? 1 : 0;

    if (qFilterToApply > 0) {
      items = items.filter(item => {
        let applied = 0;
        const f = lstForms.find(f => f.id == item.formId);
        if (filterAutonumeric != undefined && filterAutonumeric.trim() != "") {
          let autonumericField = f?.pages[0]?.fields?.find(f => f.type == "autonumeric");
          if (autonumericField && item.payload.get(autonumericField.id)?.value == filterAutonumeric.trim())
            applied += 1;
        }
        if (filterForm.id != undefined) {
          if (item.formId == filterForm.id)
            applied += 1;
        }
        if (filterDateJob != undefined && filterDateJob.trim() != "") {
          let dateJob;
          if (f?.workflow?.scheduledDate && item.payload.get(f.workflow.scheduledDate)) {
            dateJob = new Date(item.payload.get(f.workflow.scheduledDate).value);
          }
          if (dateJob == undefined || isNaN(dateJob.getTime()))
            dateJob = item._startedAt;
          if (dateJob && dateJob.toISOString().substring(0, 10) == (new Date(filterDateJob)).toISOString().substring(0, 10))
            applied += 1;
        }

        return applied == qFilterToApply;
      });
    }
    return items.filter(i => isAlive(i));
  }, [itemsStore.itemsByUsersDB, itemsPending, lstForms, filterAutonumeric, filterForm, filterDateJob]);

  const filteredItems = React.useMemo(() => {
    const _search = search.trim().toUpperCase();
    if (_search.length === 0) return my_items;
    return my_items.filter(r => r.title?.toUpperCase().includes(_search));
  }, [my_items, search]);

  const leftButton = <Button2 width={50} height={50} p="$1" variant="solid" key="ptwHome_openDrawer"
    onPress={navigation.openDrawer}>
    <ButtonIcon as={MaterialIcons} name="menu" fontWeight="$extrabold" size="xl" color="#FFF" />
  </Button2>


  return statusStore.status == "pending" ? <></> : (<>
    <StatusBar backgroundColor={"#3700B3"} barStyle="light-content" />
    <Box safeAreaTop bg="primary.400" />
    <HStack bg="$primary400" px={0} py={0} justifyContent="space-between" alignItems="center" w="100%">
      <HStack alignItems="center" maxWidth={statusStore.windowDimensions.width - 140} >
        {leftButton}
        <View style={[styles.VStack,{flex:1}]}>
          <Text style={styles.headerTitleSection} >
            Flujos de trabajo
          </Text>
        </View>
      </HStack>
      <HStack>
        <Button width={50} height={50} p="$1" variant="solid" key="itemsStore-upload"
                    onPress={async () => setShowIconInfo(true)}>
                    <ButtonIcon as={MaterialCommunityIcons} name="help-circle" fontWeight="$extrabold" size="xl" color="#FFF" />
        </Button>
        {lstForms.some(f=>f.graphId != null && f.graphId != "") ?
                <Button width={50} height={50}  p="$1" variant="solid" key="itemsStore-graph" isDisabled={!isConnected}
                            onPress={() => setShowGraph(true)}>
                            <ButtonIcon as={Ionicons} name="pie-chart-sharp" fontWeight="$extrabold" size="xl" color={isConnected ? "#FFF" : "$light400"} />
                          </Button>
                : <></>}
        <VStack mr={1}>
          {someToUpload > 0 ?
            <Badge h={21} w={22} bg="$red600" borderRadius="$full" mb={-22} mr={0} zIndex={1}
              variant="solid" alignSelf="flex-end" ><BadgeText size="2xs" color="$white" fontWeight="bold">{someToUpload}</BadgeText>
            </Badge> : null
          }
          {mustSync ?
            <Badge h={21} w={22} bg="$yellow600" borderRadius="$full" mb={-22} ml={0} zIndex={1}
              variant="solid" alignSelf="flex-end" ><BadgeText size="2xs" color="$white" fontWeight="bold">!</BadgeText>
            </Badge> : null
          }
          <Button width={50} height={50} p="$1" variant="solid" key="itemsStore-upload"
            onPress={async () => { Storage.removeItem("must_sync"); await itemsStore.upload({}); formsStore.getSubscriptions(); checkMustSync() }}>
            <ButtonIcon as={MaterialCommunityIcons} name="cloud-sync-outline" fontWeight="$extrabold" size="xl" color="#FFF" />
          </Button>
        </VStack>
      </HStack>
    </HStack>

    <VStack bg="white" flex={1}>
      <HStack bgColor={"$black"} px={5} py={1} my={0} justifyContent="center" alignItems="center" w="100%" borderBottomWidth={1} borderBottomColor={"$light300"} >
        <Button.Group isAttached colorScheme="blue" size="sm">
          <Button variant={itemsPending == false ? "solid" : "subtle"} onPress={() => setItemsPending(false)}><Text style={{color: itemsPending == false ? "white" : "black", fontWeight: "bold"}}>Todos</Text></Button>
          <Button variant={itemsPending == true ? "solid" : "subtle"} onPress={() => setItemsPending(true)}><Text style={{color: itemsPending == true ? "white" : "black", fontWeight: "bold"}}>Mis Pendientes{ itemsPending == true ? `(${filteredItems.length})` : ""} </Text></Button>
        </Button.Group>
        <Spacer></Spacer>
        <View style={{ flex: 1, maxWidth: "65%", backgroundColor: "white", borderRadius: 5, paddingHorizontal: 0, justifyContent: "center", marginLeft: 10 }}>
          <RNPicker 
            testID="rnpicker-FilterFormHeader"
            data={lstDepForms}
            pressableStyle={{ minHeight: 32, height: 32, padding: 0, paddingHorizontal: 10, borderRadius: 5 }}
            defaultValue={true}
            showSearchBar={lstDepForms.length > 10}
            searchBarPlaceHolder="Buscar..."
            selectedText={filterForm.id ? filterForm.name : "Filtrar por..."}
            selectedValue={(index: number, f: any) => setFilterForm({ id: f.id, name: f.id ? f.name : "" })}
          />
        </View>
      </HStack>
      <HStack bgColor={"$gray"} px={5} py={1} my={0} justifyContent="center" alignItems="center" w="100%" borderBottomWidth={1} borderBottomColor={"$light300"} >
      </HStack>
      <>
        {my_items.length > 0 ?
          <ItemsListRows /> : null}
        <Spacer />
        <HStack justifyContent="center">
          <VStack >
            <HStack>
              <Input w={statusStore.windowDimensions.width * 0.7} ml={5} variant="underlined">
                <InputSlot mx={5} >
                  <InputIcon as={SearchIcon} />
                </InputSlot>
                <InputField w="70%" placeholder={"Filtrar por título..."} placeholderTextColor="#8c8c8c" onChangeText={handleSearch} value={search} />
                {search.length > 0 ? (
                  <InputSlot onPress={() => { setSearch(""); offsetRef.current = 0; }} mx={5}>
                    <InputIcon as={Ionicons} name="close-circle" size="md" color="#8c8c8c" />
                  </InputSlot>
                ) : null}
              </Input>
              <Spacer />
            </HStack>
          </VStack>
          <Spacer />
          <Button2 margin={2} width={50} height={50} p="$1" borderRadius="$full" variant="solid" bgColor="$green600"
            onPress={() => setSelectNewForm(true)}>
            <ButtonIcon as={Ionicons} name="add" fontWeight="$extrabold" size="xl" color="#FFF" />
          </Button2>

          <Modal
            visible={!!selectNewForm}
            transparent={true}
            onRequestClose={() => setSelectNewForm(false)}
            animationType="none"
          >
            <Pressable 
              style={styles.modalBackdrop} 
              onPress={() => setSelectNewForm(false)} 
            />
            <View style={styles.modalContent}>
              <HStack w="100%" px={20} py={15} borderBottomWidth={1} borderBottomColor="#eee" justifyContent="space-between" alignItems="center">
                <Text style={{ fontSize: 18, fontWeight: 'bold', color: '#333' }}>
                  Iniciar:
                </Text>
                <Pressable onPress={() => setSelectNewForm(false)}>
                  <Ionicons name="close" size={28} color="#666" />
                </Pressable>
              </HStack>
              <ScrollView style={{ maxHeight: statusStore.windowDimensions.height * 0.7 }} contentContainerStyle={{paddingBottom:50}}>
                <Box w="100%">
                  {newFormList.map((item: any, idx: number) => (
                    <Pressable 
                      key={"btn_new_" + idx} 
                      onPress={() => {
                        setSelectNewForm(false);
                        newItem(item.dept, item.form);
                      }}
                      style={styles.modalItem}
                    >
                      <MaterialCommunityIcons name="format-list-checks" size={24} color="#666" />
                      <Text style={styles.modalItemText}>{item.form.name}</Text>
                    </Pressable>
                  ))}
                </Box>
              </ScrollView>
              <View style={{ height: 20 }} />
            </View>
          </Modal>
          <Modal
            visible={!!filterView}
            transparent={true}
            onRequestClose={() => setFilterView(false)}
            animationType="none"
          >
            <Pressable 
              style={styles.modalBackdrop} 
              onPress={() => setFilterView(false)} 
            />
            <View style={styles.modalContent}>
              <HStack w="100%" px={20} py={15} borderBottomWidth={1} borderBottomColor="#eee" justifyContent="space-between" alignItems="center">
                <Text style={{ fontSize: 18, fontWeight: 'bold', color: '#333' }}>
                  Filtro sobre la vista actual
                </Text>
                <Pressable onPress={() => setFilterView(false)}>
                  <Ionicons name="close" size={28} color="#666" />
                </Pressable>
              </HStack>
              <ScrollView style={{ maxHeight: statusStore.windowDimensions.height * 0.7, paddingHorizontal: 20 }}>
                <Box py={10}>
                  <Text fontSize={16} color="$light500" mb={5}>
                    Fecha Programada
                  </Text>
                  <DateTimePicker onChange={(v) => { setFilterDateJob(v) }} type={"date"} value={filterDateJob} />
                  
                  <Text fontSize={16} color="$light500" mt={20} mb={5}>
                    Formulario
                  </Text>
                  <RNPicker 
                    testID="rnpicker-MultipleEl"
                    data={(lstForms.concat({ id: undefined, name: "", f: undefined }) || [])?.map((f, idx) => ({
                      id: f.id, 
                      name: f.name, 
                      f
                    }))}
                    defaultValue={true}
                    showSearchBar={(lstForms || []).length > 10} 
                    searchBarPlaceHolder={"Buscar....."}
                    selectedText={filterForm.name}
                    selectedValue={(index: number, f: { id: string, name: string, f: string }) => setFilterForm({ id: f.id, name: f.name })}
                  />

                  <Text fontSize={16} color="$light500" mt={20} mb={5}>
                    Identificador de Registro
                  </Text>
                  <Input w="100%" variant="underlined">
                    <InputSlot mr={10}>
                      <InputIcon as={GripVerticalIcon} />
                    </InputSlot>
                    <InputField 
                      keyboardType="number-pad" 
                      placeholder="" 
                      placeholderTextColor="#8c8c8c" 
                      onChangeText={setFilterAutonumeric} 
                    />
                  </Input>
                </Box>
              </ScrollView>
              <View style={{ height: 40 }} />
            </View>
          </Modal>
        </HStack>
      </>
      <View style={{ height: keyboardHeight > 0 && Platform.OS === 'android' ? keyboardHeight : 0 }} />
      </VStack>
    <ModalInfo alertDialog={alertDialog} setAlertDialog={setAlertDialog} />
    <ModalIconInfo showIconInfo={showIconInfo} setShowIconInfo={setShowIconInfo} statusStore={statusStore} isPTW={false} />  
    <ModalGraph showMe={showGraph} setShowMe={setShowGraph} statusStore={statusStore} isPTW={false} authenticationStore={authenticationStore} lstForms={lstForms}/>
  </>
  )
})


const styles = StyleSheet.create({
  itemContainer: {
    backgroundColor: glueStyles.colors.white,
    borderBottomColor: glueStyles.colors.light300,
    borderBottomWidth: 1,
    justifyContent: 'center',
    minHeight: 70,
    width: '100%',
  },
  innerRow: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 12,
    paddingVertical: 8,

  },
  contentWrapper: {
    flex: 1,
    marginHorizontal: 10, width: "80%",
    justifyContent: 'center',
    flexBasis: "70%"
  },
  titleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 2,
  },
  itemTitle: {
    fontSize: glueStyles.fontSizes.md,
    fontWeight: glueStyles.fontWeights.medium,
    color: glueStyles.colors.light700, // Gray 800
    marginRight: 6,
    flexShrink: 1,
  },
  subInfoRow: {
    flexDirection: 'row',
    alignItems: 'center',
    flex:1,
    width:"90%"
  },
  subText: {
    fontSize: 12,
    color: glueStyles.colors.light500, // Gray 500
    marginRight:3, minWidth:"25%"
  },
  hiddenActionWrapper: {
    alignItems: 'center',
    backgroundColor: glueStyles.colors.light100,
    flexDirection: 'row',
    flex: 1, marginHorizontal: 2
  },
  actionGroup: {
    flexDirection: 'row',
    height: '100%',
  },
  actionButton: {
    width: 55,
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },

  headerTitleSection: {
    fontWeight: glueStyles.fontWeights.normal,
    color: '#fff',
    fontSize: glueStyles.fontSizes.lg
  },
  headerSubTitleSection: {
    fontWeight: glueStyles.fontWeights.normal,
    color: '#fff',
    fontSize: glueStyles.fontSizes["2xs"]
  },
  HStack: {
    flexDirection: "row"
  },
  VStack: {
    flexDirection: "column"
  },
  modalBackdrop: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.5)',
  },
  modalContent: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: '#fff',
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    maxHeight: '85%',
    shadowColor: "#000",
    shadowOffset: { width: 0, height: -3 },
    shadowOpacity: 0.1,
    shadowRadius: 5,
    elevation: 10,
  },
  modalItem: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 15,
    paddingHorizontal: 20,
    borderBottomWidth: 1,
    borderBottomColor: '#f0f0f0',
  },
  modalItemText: {
    fontSize: 16,
    color: '#333',
    marginLeft: 15,
  }
});